import { render, staticRenderFns } from "./InternalRecipientCategories.vue?vue&type=template&id=a3836c5a&"
import script from "./InternalRecipientCategories.vue?vue&type=script&lang=js&"
export * from "./InternalRecipientCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports